import React from 'react';
import { FormField } from './FormField';
import Dropdown, { DropdownOption } from './Dropdown';

interface SelectFieldProps {
    id: string;
    label: string;
    value: string | number;
    onChange: (value: string | number) => void;
    options: DropdownOption[];
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    tooltip?: string;
    error?: string;
    className?: string;
}

export const SelectField: React.FC<SelectFieldProps> = ({
    id,
    label,
    value,
    onChange,
    options,
    required = false,
    disabled = false,
    placeholder,
    tooltip,
    error,
    className = ''
}) => (
    <FormField
        label={label}
        id={id}
        required={required}
        tooltip={tooltip}
        error={error}
    >
        <Dropdown
            id={id}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            disabled={disabled}
            invalid={!!error}
            className={className}
        />
    </FormField>
);
